import React from 'react';
import {
  Col,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  UncontrolledTooltip
} from 'reactstrap';
import classnames from 'classnames';
import './etapas.common.styles.css';
import MaterialContainer from './material/material.container';
import MacroscopiaContainerIntl from './macroscopia/tabs/macroscopia.intl';
import MicroscopiaContainer from './microscopia/microscopia.container';
import ImunoContainerIntl from './imuno/imuno.intl';
import HistoquimicaContainerIntl from './histo/histo.intl';
import FishContainerIntl from './fish/fish.intl';
import CishContainerIntl from './cish/cish.intl';
import PcrContainerIntl from './pcr/pcr.intl';
import CongelacaoContainerIntl from './congelacao/congelacao.intl';
import NotasContainerIntl from './notas/notas.intl';
import ErratasContainerIntl from './erratas/erratas.intl';
import ConclusaoContainer from './conclusao/conclusao.container';
import { ordemSugeridaEtapas } from './etapas.common.util';
import { etapasEnum, etapasIndexEnum } from '@common/util/defaultValues';
import IntlMessage from '../../../helpers/intlMessage';

const EtapasCommonPage = props =>  (
  <Col
    className='paddingZero'
    sm={props.detalhes === undefined ? '0' : undefined}
  >
    {props.detalhes !== undefined && (
      <div>
        <div style={{ height: '100%' }} className='mv-detalhes-container'>
          <div className='step-by-container'>
            <Nav tabs>
              {ordemSugeridaEtapas.map(item => {
                let noborder = '';
                let myStyle = { borderLeftWidth: 0 };

                if (item.etapa === etapasEnum.ERRATA) {
                  myStyle = { borderRightWidth: 0 };
                  noborder = ' noborder';
                }

                const myclass =
                  props.getNavItemClassName(item.etapa, item.tab) + noborder;
                const isDisabled = props.etapaNaoAplicavel(item.etapa);
                return (
                  <NavItem key={item.tab} style={myStyle} className={myclass}>
                    <NavLink
                      id={item.id}
                      disabled={isDisabled}
                      className={classnames({
                        active: props.active === item.tab
                      })}
                      onClick={() => {
                        props.verificaEditor(item.tab);
                      }}
                    >
                      <div>
                        <p>
                          {
                          // item.etapa.charAt(0).toUpperCase() +
                            // item.etapa.slice(1)
                            <IntlMessage id={'dashboards.examDetails.step.' + item.etapa.toLocaleLowerCase()} />
                            }

                        </p>
                      </div>
                      <UncontrolledTooltip placement='top' target={item.id}>
                        {'CTRL+ALT+' + (item.etapa === 'CONCLUSAO' || item.etapa === 'ERRATA' ? (item.etapa.substr(0,1)) : item.tab  )}
                      </UncontrolledTooltip>
                    </NavLink>
                    <div className='triangle'></div>
                  </NavItem>
                );
              })}
            </Nav>
          </div>
          <TabContent activeTab={props.active}>
            <TabPane tabId={etapasIndexEnum.MATERIAL}>
              {props.active === etapasIndexEnum.MATERIAL && (
                <MaterialContainer history={props.history} />
              )}
            </TabPane>
            <TabPane tabId={etapasIndexEnum.MACRO}>
              {props.active === etapasIndexEnum.MACRO && (
                <MacroscopiaContainerIntl history={props.history} />
              )}
            </TabPane>
            <TabPane tabId={etapasIndexEnum.MICRO}>
              {props.active === etapasIndexEnum.MICRO && (
                <MicroscopiaContainer history={props.history} />
              )}
            </TabPane>
            <TabPane tabId={etapasIndexEnum.HISTO}>
              {props.active === etapasIndexEnum.HISTO && (
                <HistoquimicaContainerIntl history={props.history} />
              )}
            </TabPane>
            <TabPane tabId={etapasIndexEnum.IMUNO}>
              {props.active === etapasIndexEnum.IMUNO && (
                <ImunoContainerIntl history={props.history} />
              )}
            </TabPane>
            <TabPane tabId={etapasIndexEnum.FISH}>
              {props.active === etapasIndexEnum.FISH && (
                <FishContainerIntl history={props.history} />
              )}
            </TabPane>
            <TabPane tabId={etapasIndexEnum.CISH}>
              {props.active === etapasIndexEnum.CISH && (
                <CishContainerIntl history={props.history} />
              )}
            </TabPane>
            <TabPane tabId={etapasIndexEnum.PCR}>
              {props.active === etapasIndexEnum.PCR && (
                <PcrContainerIntl history={props.history} />
              )}
            </TabPane>
            <TabPane tabId={etapasIndexEnum.CONGELACAO}>
              {props.active === etapasIndexEnum.CONGELACAO && (
                <CongelacaoContainerIntl history={props.history} />
              )}
            </TabPane>
            <TabPane tabId={etapasIndexEnum.NOTAS}>
              {props.active === etapasIndexEnum.NOTAS && (
                <NotasContainerIntl history={props.history} />
              )}
            </TabPane>
            <TabPane tabId={etapasIndexEnum.CONCLUSAO}>
              {props.active === etapasIndexEnum.CONCLUSAO && (
                <ConclusaoContainer history={props.history} />
              )}
            </TabPane>
            <TabPane tabId={etapasIndexEnum.ERRATA}>
              {props.active === etapasIndexEnum.ERRATA && (
                <ErratasContainerIntl history={props.history} />
              )}
            </TabPane>
          </TabContent>
        </div>
      </div>
    )}
  </Col>
);

export default EtapasCommonPage;



// WEBPACK FOOTER //
// ./src/pages/laudo/etapas/etapas.common.page.js